import { initializeGoogleAnalytics } from '@/app/analytics/initialGoogleAnalytics'
import { startBlogNavigation } from './navigation'

initializeGoogleAnalytics()
startBlogNavigation()
